require('plugins/icomoon/style.css');
require('plugins/sweetalert/dist/sweetalert.css');
require('plugins/animate.css/animate.min.css');
require('plugins/swiper/dist/css/swiper.min.css');
require('styles/common/util.scss');
require('styles/common/common.scss');
require('styles/pages/user-case-detail.scss');

require('script!plugins/jquery/jquery.min');
// require('script!plugins/hammer.js/hammer.min');
// require('script!plugins/Boxer/jquery.fs.boxer');
require('script!plugins/sweetalert/dist/sweetalert.min.js');
require('script!plugins/jquery.form.min');
require('../common/form-validation.coffee');
require('script!plugins/swiper/dist/js/swiper.js');
require('../common/wxshare.coffee');
require('../common/header.coffee');

var getpx = function (val) {
  return $(document).width() / 750 * val;
};

$(function () {
  var $selects = $('.select-bar .select-list .select');
  var $lists = $('.select-bar .drop-down-wrapper .list-item');
  var $dropDown = $('.select-bar .drop-down');
  var $mask = $('.select-bar .drop-down .dropback-mask');

  $selects.click(function () {
    var $this = $(this);
    $this.siblings().removeClass('active');
    $this.toggleClass('active');

    if ($this.hasClass('active')) {
      var index = $this.index();
      $lists.eq(index).addClass('active').siblings().removeClass('active');
      $dropDown.addClass('active');
    } else {
      $lists.removeClass('active');
      $dropDown.removeClass('active');
    }
  });

  $mask.click(function () {
    $selects.removeClass('active');
    $dropDown.removeClass('active');
  });

  new Swiper('.recommend .swiper-container', {
    freeMode: true,
    slidesPerView: 2.419354839,
    slidesOffsetBefore: getpx(24)
    // slidesOffsetAfter: getpx 24
  });
});

$(function () {
  new Swiper('.swiper-container', {
    loop: true,
    pagination : '.swiper-pagination',
    paginationType : 'fraction'
  });

  var preventScroll = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };

  $('.swiper-container').click(function (e) {
    if (e.target.tagName.toLowerCase() === 'img') {
      $('.swiper-block .wrapper').addClass('active');
      document.addEventListener(
        'touchmove',
        preventScroll,
        { passive: false }
      );
    } else {
      $('.swiper-block .wrapper').removeClass('active');
      document.removeEventListener('touchmove', preventScroll);
    }
  });

  $('.detail .show-more').click(function () {
    $('.detail').toggleClass('active');
  });

  $('.float-share').click(function () {
    $(this).toggleClass('active');
  });

  $(document).scroll(function () {
    $('.float-share').removeClass('active');
  });
});



/*****************
 ** WEBPACK FOOTER
 ** ./pages/user-case-detail.js
 ** module id = 0
 ** module chunks = 27
 **/